import { TLSMode } from "src/api/connectApi/types";

export const mTLSCertificatePlaceholder = `-----BEGIN CERTIFICATE-----
XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
-----END CERTIFICATE-----`;

export const mTLSKeyPlaceholder = `-----BEGIN KEY-----
XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
-----END KEY-----`;

export const mTLSCACertificatePlaceholder = `-----BEGIN CERTIFICATE-----
XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
-----END CERTIFICATE-----`;

export const MTLS_BE_DEFAULTS: {
  mode: TLSMode;
  client_certificate: string;
  ca_certificate: string;
} = {
  mode: "verify-full",
  client_certificate: "",
  ca_certificate: "",
};
